import { SparklesFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';

import classes from './ai-plus-button-scss';

type Props = { onClick: () => void; dataHook?: string };

export const AiPlusButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ onClick, dataHook }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={classes.button}
        onClick={onClick}
        data-hook={dataHook}
      >
        <SparklesFilledSmall fill="currentColor" />
      </button>
    );
  }
);
